<template>
  <v-list-item :disabled="!!action.disabled" @click="onActionClick">
    <v-list-item-icon class="mr-4 d-flex align-center justify-center">
      <v-icon
        medium
        :class="{ [action.iconClass]: !action.disabled }"
        :style="action.iconStyle"
      >
        {{ action.icon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title
      :class="{ [action.textClass]: !action.disabled }"
      v-text="action.text"
    ></v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "TableActionsItem",
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onActionClick() {
      this.$emit("click", this.action.emit, this.action)
    },
  },
}
</script>
